import { createEvent, restore, sample } from 'effector'
import { CreateBlock, UpdateBlock } from './types'
import { fx } from '../../../../../libs'

export const createBlockPartnerMounted = createEvent<CreateBlock>()

export const updateBlockPartnerMounted = createEvent<UpdateBlock>()

export const closeModal = createEvent()

export const createBlockPartner = fx<CreateBlock, void>({
  method: 'POST',
  url: `/promo/cash_booster/partner_block_create`,
})

export const updateBlockPartner = fx<Omit<UpdateBlock, 'id'>, void>({
  method: 'PUT',
  url: `/promo/cash_booster/partner_block_update/`,
})

export const $isSuccessCreate = restore(
  createBlockPartner.doneData.map(() => true),
  false,
).reset(closeModal)

export const $isSuccessUpdate = restore(
  updateBlockPartner.doneData.map(() => true),
  false,
).reset(closeModal)

sample({
  clock: createBlockPartnerMounted,
  fn: (data) => {
    if (data.blockedToDate == '') {
      data.blockedToDate = null
    }
    return {
      url: `/promo/cash_booster/partner_block_create`,
      body: {
        id: data.id,
        blockedFromDate: data.blockedFromDate,
        blockedToDate: data.blockedToDate,
      },
    }
  },
  target: createBlockPartner,
})

sample({
  clock: updateBlockPartnerMounted,
  fn: (data) => {
    if (data.blockedToDate == '') {
      data.blockedToDate = null
    }
    return {
      url: `/promo/cash_booster/partner_block_update/${data.id}`,
      body: {
        blockedFromDate: data.blockedFromDate,
        blockedToDate: data.blockedToDate,
        isDeleted: data.isDeleted,
      },
    }
  },
  target: updateBlockPartner,
})
